import { render, staticRenderFns } from "./QuickSearchCategoryMenu.vue?vue&type=template&id=0b9cb7f5&"
import script from "./QuickSearchCategoryMenu.vue?vue&type=script&lang=ts&"
export * from "./QuickSearchCategoryMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports